// components/receptionist/PrintAppointmentSlip80mm.jsx
// ✅ Updated with printed timestamp reduced, centered, and moved to end

export const printWalkInReceipt = (appt) => {
  if (!appt) return alert("Invalid appointment");

  const printedAt = new Date().toLocaleString();

  // ✅ Convert time to 12-hour format
  const formatTime12Hour = (time24) => {
    if (!time24) return "-";
    const [hours, minutes] = time24.split(":");
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  const vitalsLine = appt.vitals
    ? [
        appt.vitals.bp && `BP:${appt.vitals.bp}`,
        appt.vitals.weight && `Wt:${appt.vitals.weight}`,
        appt.vitals.spo2 && `SpO2:${appt.vitals.spo2}%`,
        appt.vitals.temperature && `Temp:${appt.vitals.temperature}`,
        appt.vitals.height && `Ht:${appt.vitals.height}`,
        appt.vitals.bmi && `BMI:${appt.vitals.bmi}`,
      ]
        .filter(Boolean)
        .join(" | ")
    : null;

  const html = `
  <html>
  <head>
    <title>Appointment Slip</title>
    <style>
      * {
        box-sizing: border-box;
      }
      body {
        margin: 0;
        padding: 0;
        font-family: monospace;
        background: #fff;
      }
      .slip {
        width: 302px; /* 80mm */
        padding: 8px;
      }
      .center {
        text-align: center;
      }
      .bold {
        font-weight: bold;
      }
      .title {
        font-size: 18px;
        font-weight: bold;
      }
      .divider {
        border-top: 1px dashed #000;
        margin: 6px 0;
      }
      .separator {
        border-top: 2px solid #000;
        margin: 8px 0;
      }
      .row {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        margin: 2px 0;
      }
      .token {
        font-size: 34px;
        font-weight: bold;
        margin: 6px 0;
      }
      .small {
        font-size: 11px;
      }
      .section-heading {
        font-size: 13px;
        font-weight: bold;
        margin: 8px 0 4px 0;
      }
      /* ✅ Reduced size for printed timestamp */
      .printed-timestamp {
        text-align: center;
        font-size: 8px;
        color: #666;
        margin-top: 6px;
      }
      .developer-credit {
        text-align: center;
        margin-top: 8px;
        padding-top: 6px;
        border-top: 1px solid #000;
        font-size: 9px;
        color: #333;
      }
      @media print {
        body { margin: 0; }
      }
    </style>
  </head>

  <body>
    <div class="slip">

      <div class="center">
        <div class="title">Zainab Medical & Children Care Centre </div>
        <div class="small">OPD Appointment Slip</div>
      </div>

      <div class="divider"></div>

      <div class="center">
        <div class="small">Token / Appt #</div>
        <div class="token">${appt.appointmentNumber || "-"}</div>
      </div>

      <div class="divider"></div>

      <!-- Patient Information Section -->
      <div class="section-heading">Patient Information</div>

      <div class="row">
        <span class="bold">MR</span>
        <span>${appt.mrCode || "-"}</span>
      </div>

      <div class="row">
        <span class="bold">Name</span>
        <span>${appt.pName}</span>
      </div>

      <div class="row">
        <span class="bold">Father</span>
        <span>${appt.fatherName || "-"}</span>
      </div>

      <div class="row">
        <span class="bold">Age</span>
        <span>${appt.age || "-"}</span>
      </div>

      <div class="row">
        <span class="bold">Contact</span>
        <span>${appt.contact || "-"}</span>
      </div>

      <!-- Separator line between sections -->
      <div class="separator"></div>

      <!-- Appointment Schedule Section -->
      <div class="section-heading">Appointment Schedule</div>

      <div class="row">
        <span class="bold">Dept</span>
        <span>${appt.department}</span>
      </div>

      <div class="row">
        <span class="bold">Doctor</span>
        <span>${appt.doctor?.name || "-"}</span>
      </div>

      <div class="row">
        <span class="bold">Date</span>
        <span>${appt.date}</span>
      </div>

      <div class="row">
        <span class="bold">Time</span>
        <span>${formatTime12Hour(appt.time)}</span>
      </div>

      ${
        vitalsLine
          ? `
        <div class="divider"></div>
        <div class="small bold">Vitals</div>
        <div class="small">${vitalsLine}</div>
      `
          : ""
      }

      ${
        appt.payment?.feePaid
          ? `
        <div class="divider"></div>
        <div class="row">
          <span class="bold">Fee</span>
          <span>Rs ${appt.payment.feePaid}</span>
        </div>
      `
          : ""
      }

      <div class="divider"></div>

      <div class="center small" style="margin-top:6px;">
        Please arrive 15 min earlier
      </div>

      <div class="center small">
        Ph: +923152189910 (Whatsapp Only) / +923153051011
      </div>

      <!-- Developer credit section -->
      <div class="developer-credit">
        Computer Software Developed by<br/>
        Bilal Consultancy, Ph: 03152311183
      </div>

      <!-- ✅ Printed timestamp moved to the very end with smaller size and center alignment -->
      <div class="printed-timestamp">
        Printed: ${printedAt}
      </div>

    </div>

    <script>
      window.onload = () => window.print();
    </script>
  </body>
  </html>
  `;

  const w = window.open("", "_blank", "width=340,height=700");
  w.document.write(html);
  w.document.close();
};